// extracted by mini-css-extract-plugin
export default {"privacyPolicyContainer":"PrivacyPolicy_privacyPolicyContainer__MUA0A"};